var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:[{ loaded: _vm.loaded }, _vm.cssClass]},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }